import axios from 'axios';
import cfac22 from '../cfac22';

export default async function authToken(uId) {
  const auth = window.btoa(`${cfac22('username')}:${cfac22('password')}`);
  const response = await axios({
    method: 'post',
    url: `${cfac22('API_HOST_V2')}/auth`,
    headers: {
      Authorization: `Basic ${auth}`,
      uid: uId ?? null,
      'Full-Url': window.location.href,
    },
  });

  return response.data.token;
}
